import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { motion } from "framer-motion";
import { FaLinkedin, FaGithub, FaEnvelope, FaDownload } from "react-icons/fa";
import "./Hero.css";

const textVariants = {
  hidden: { opacity: 0, y: 20 },
  visible: (i = 1) => ({
    opacity: 1,
    y: 0,
    transition: { delay: i * 0.3, duration: 0.8 }
  })
};

const Hero = () => {
  return (
    <motion.section
      className="hero bg-dark text-white text-center py-5"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 1 }}
    >
      <Container>
        <Row>
          <Col>
            {/* Main Heading */}
            <motion.h1
              className="animated-heading"
              custom={1}
              variants={textVariants}
              initial="hidden"
              animate="visible"
            >
              Hello, I'm <span className="highlight">Pratik Satalkar</span>
            </motion.h1>

            {/* Subheading with Freelance Badge */}
            <motion.div
              className="animated-subheading d-flex justify-content-center align-items-center flex-wrap"
              custom={2}
              variants={textVariants}
              initial="hidden"
              animate="visible"
            >
              <h2>
                A <span className="highlight">Full Stack Developer</span>
              </h2>
              <motion.span
                className="freelance-badge"
                initial={{ opacity: 0, scale: 0.8 }}
                animate={{ opacity: 1, scale: 1 }}
                transition={{ delay: 1, type: "spring", stiffness: 120 }}
              >
                🚀 Available for Freelance Projects
              </motion.span>
            </motion.div>

            {/* Paragraph */}
            <motion.p
              className="animated-paragraph"
              custom={3}
              variants={textVariants}
              initial="hidden"
              animate="visible"
            >
              Building Bridges Between Front-End and Back-End, Transforming Ideas into Web Reality.{" "}
              <strong className="freelance-highlight">Currently open to freelance opportunities worldwide.</strong>
            </motion.p>

            {/* Social Icons */}
            <motion.div
              className="social-icons animated-social"
              custom={4}
              variants={textVariants}
              initial="hidden"
              animate="visible"
            >
              <a
                href="https://www.linkedin.com/in/pratiksatalkar"
                target="_blank"
                rel="noopener noreferrer"
                className="icon"
              >
                <FaLinkedin />
              </a>
              <a
                href="https://github.com/Pratik9307"
                target="_blank"
                rel="noopener noreferrer"
                className="icon"
              >
                <FaGithub />
              </a>
              <a
                href="mailto:satalkarpratik0@gmail.com"
                className="icon"
              >
                <FaEnvelope />
              </a>
            </motion.div>

            {/* Resume Download Button */}
            <motion.a
              className="btn btn-primary btn-lg mt-3 download-button"
              href="/resume/Pratik-Satalkar-React-Developer.pdf"
              download="Pratik_Satalkar_Resume"
              custom={5}
              variants={textVariants}
              initial="hidden"
              animate="visible"
            >
              <FaDownload className="download-icon" /> Download Resume
            </motion.a>
          </Col>
        </Row>
      </Container>
    </motion.section>
  );
};

export default Hero;
